/**
 * Font size
 *
 * @package lib-components
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

/**
 * Font size enum
 */
export enum FONT_SIZE {
	BASE = "base",
	XSMALL = "x-small",
	SMALL = "small",
	MEDIUM = "medium",
	LARGE = "large",
	XLARGE = "x-large",
	XXLARGE = "xx-large",
	XXXLARGE = "xxx-large"
}

export type FONT_SIZE_string = keyof typeof FONT_SIZE;

export type FONT_SIZE_css_variable = `--font-size-${FONT_SIZE}`;
